import * as React from 'react';
import { SVGProps } from 'react';

const IconLineAndBarChartSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M26 9.07 18.346 2l-5.124 6.153-4.937-3.459L1 12.673l2.197 2.041 5.508-6.063 5.056 3.541 4.869-5.847 5.337 4.93L26 9.07Z" />
    <path d="M21 12h-3v14h3V12ZM11 14H8v12h3V14ZM6 19H3v7h3v-7ZM13 17h3v9h-3v-9ZM23 19h3v7h-3v-7Z" />
  </svg>
);
export default IconLineAndBarChartSizeL;
